// Module
var code = "<div class=\"input-field\"> <div class=\"recaptcha-field-wrapper\" class=\"col s12 l12\"> <div id=\"recaptcha-container\"></div> <input type=\"hidden\" id=\"{{ field.$_id }}\" ng-required=\"true\" ng-model=\"form.data[field.schema.name]\" fg-field-input/> </div> </div> ";
// Exports
export default code;